import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

// import uploaded from '../../asset/uploaded.svg';
import { useDispatch, useSelector } from 'react-redux';
import { readNotification, selectNotification } from '../../redux/notificationReducer';
import moment from 'moment';
import { useEffect } from 'react';
import { selectUser } from '../../redux/userReducer';

export const NotificationModal = ({ isModal, setIsModal }) => {

  const notification = useSelector(selectNotification);

  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useEffect(() => {
    if ( user && user._id && notification && notification.notification && notification.notification.status === false && notification.notification._id ) {
      dispatch(readNotification(notification.notification._id, user._id));
    }
  }, [notification, user, dispatch])

  return (
    <>
      {notification && notification.notification && 
        <Transition appear show={isModal} as={Fragment}>
          <Dialog
            as="div"
            onClose={() => setIsModal(false)}
            className="relative z-50">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0">
              <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            </Transition.Child>
            <div className="fixed inset-0 flex items-center bg-gray-200 bg-transparent justify-center ">
              {/* The actual dialog panel  */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className=" max-w-xs transform transition-all md:max-w-lg">
                  <div className="relative bg-white p-6 text-center shadow-xl font-millerBanner">
                    <button
                      type="button"
                      className="absolute -top-2 -right-4 text-red-600 bg-white border-2 border-gray-200 hover:bg-gray-200 rounded-full text-sm p-1.5 ml-auto inline-flex items-center"
                      onClick={() => setIsModal(false)}>
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clipRule="evenodd"></path>
                      </svg>
                    </button>
                    <div className="py-6 px-6 lg:px-8">
                      <h3 className="mb-4 text-lg md:text-3xl text-center font-millerBanner text-red-600 ">
                        {notification.notification.title}
                      </h3>

                      <div className='flex flex-col w-full mx-6 mb-10 text-sm md:text-xl text-center font-universLight text-ato-form-text md:font-thin gap-4'>
                        {/* <div className='flex flex-row w-full'>
                          <div className='w-2/6'>From</div>
                          <div>:</div>
                          <div className='w-full'>{notification.artist.firstname} {notification.artist.lastname}</div>
                        </div> */}
                        <div className='flex flex-row w-full'>
                          <div className='w-2/6'>Time</div>
                          <div>:</div>
                          <div className='w-full'>{moment(notification.notification.createdAt).format('YYYY-MM-DD hh:mm:ss')}</div>
                        </div>
                        <div className='flex flex-row w-full'>
                          <div className='w-2/6'>Message</div>
                          <div>:</div>
                          <div className='w-full text-left'><div className='ml-6'>{notification.notification.message}</div></div>
                        </div>
                      </div>
                      <div className=" flex justify-center">
                        <button
                          type="submit"
                          className=" max-w-md text-black bg-ato-upload-button text-center py-2 px-6 font-millerBanner"
                          onClick={() => setIsModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      }
    </>
  );
};
